export const ORGANIZATION_TARGET_OPTIONS = [
    'self',
    'all',
    'descendants',
];